import { render, staticRenderFns } from "./AlternativeCalculationsSettingsView.vue?vue&type=template&id=20d3df05&scoped=true"
import script from "./AlternativeCalculationsSettingsView.vue?vue&type=script&lang=ts"
export * from "./AlternativeCalculationsSettingsView.vue?vue&type=script&lang=ts"
import style0 from "./AlternativeCalculationsSettingsView.vue?vue&type=style&index=0&id=20d3df05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3df05",
  null
  
)

export default component.exports